module.exports = __webpack_public_path__ + "img/Group 74.f2daa94e.png";